module.exports = __webpack_public_path__ + "img/facilitiesicn.da1b59a6.svg";